import { render, staticRenderFns } from "./RelatedCommunities.vue?vue&type=template&id=213768a0"
import script from "./RelatedCommunities.vue?vue&type=script&lang=js"
export * from "./RelatedCommunities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports